import React from 'react';
import CustomerCard from './CustomerCard';
import customerData from '../../data/customer-data';

export default () => (
  <section id="testimonials" className="py-20 lg:pb-20 lg:pt-20">
    <div className="bg-primary py-12">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl lg:text-5xl font-semibold text-white">Testimonials</h2>
        <p className="text-xl lg:text-2xl mt-6 font-light text-white">What customers are saying</p>
      </div>
    </div>
    <div className="container mx-auto">
      <div className="flex flex-col md:flex-row md:-mx-3 mt-12">
        {customerData.slice(0, 3).map(customer => (
          <div key={customer.customerName} className="flex flex-1 px-3">
            <CustomerCard customer={customer} />
          </div>
        ))}
      </div>
    </div>
  </section>
);
